import React, { useEffect, useState } from "react";
import Header from "../Header/Header";
import AllowanceCard from "./AllowanceCard";
import allowanceService from "../Services/allowanceService";
import CustomHeading from "../../components/common/CustomHeading";
import { useNavigate } from "react-router-dom";
import AllowanceList from "./AllowanceList";

const AllowancePage = () => {

  const [pendingCount, setPendingCount] = useState(0);

  const navigate = useNavigate();

  const fetchAllowancePendingCount = async () => {
    try {
      const response = await allowanceService.getAllowancePendingCount();
      const data = response.data;
      setPendingCount(data.count);
    } catch (error) {
      console.error('Error fetching allowance pending count:', error);
    }

  }

  useEffect(()=>{
    fetchAllowancePendingCount()
  },[])
  return (
    <div>
      <Header />
      <div className="px-6 pt-28 pb-10">
        <div className="flex justify-between items-center mb-8">
          <div className="flex items-center gap-4">
           <CustomHeading title="Allowance" textColor={"primary"} />
            <div className="px-2 py-1 border text-xs text-blue-600 border-blue-600 bg-blue-100 rounded-full">
              Note: This card data auto-refreshes every 60 minutes
            </div>
          </div>
          <div onClick={()=>{
navigate('/hr-employee-allowance/request-list')
          }} className="bg-white cursor-pointer px-4 py-2 rounded-[10px] shadow">
             Allowance Requests:
            <span className="font-semibold text-gray-800">({pendingCount})</span>
            </div>
        </div>
        <AllowanceCard />
        <AllowanceList/>
      </div>
    </div>
  );
};

export default AllowancePage;
